import React from 'react'

import SubstanceFormStorehouse from '../../Form/Storehouse'

const SubstanceContainerStorehouse = () => <SubstanceFormStorehouse />

export default SubstanceContainerStorehouse
